import { render, staticRenderFns } from "./vigne-marina-coppi.vue?vue&type=template&id=5fee9f5b&scoped=true"
import script from "./vigne-marina-coppi.vue?vue&type=script&lang=js"
export * from "./vigne-marina-coppi.vue?vue&type=script&lang=js"
import style0 from "./vigne-marina-coppi.vue?vue&type=style&index=0&id=5fee9f5b&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5fee9f5b",
  null
  
)

export default component.exports